import React, { useEffect, useState } from 'react';
import axios from 'axios';
import config from '../../config';

const NewestTerms = () => {
  const [terms, setTerms] = useState([]);
  const [hoveredTermId, setHoveredTermId] = useState(null);
  const [count, setCount] = useState(10); // State to track the count of terms to display
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchTerms = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get(`${config.apiEndpoint}/api/Terms/NewestUpdates/${count}`);
        setTerms(response.data);
      } catch (error) {
        console.error('Error fetching newest terms:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchTerms();
  }, [count]);

  const formatTermTime = (term) => {
    const startTime = new Date(term.date);
    const endTime = new Date(startTime.getTime() + (term.termType ? term.termType.duration * 60000 : 0));
    const formattedStartTime = startTime.toLocaleTimeString("sk-SK", { hour: '2-digit', minute: '2-digit', hour12: false });
    const formattedEndTime = endTime.toLocaleTimeString("sk-SK", { hour: '2-digit', minute: '2-digit', hour12: false });
    return `${formattedStartTime} - ${formattedEndTime}`;
  };

  const formatTime = (date) => {
    return new Date(date).toLocaleTimeString("sk-SK", { hour: '2-digit', minute: '2-digit', hour12: false });
  };

  const formatDate = (date) => {
    return `${new Date(date).getDate()}.${new Date(date).getMonth() + 1 < 10 ? `0${new Date(date).getMonth() + 1}` : new Date(date).getMonth() + 1}.${new Date(date).getFullYear()}`;
  };

  const handleMouseEnter = (id) => setHoveredTermId(id);

  const handleMouseLeave = () => setHoveredTermId(null);

  const handleTermClick = (termId) => console.log(`Term clicked: ${termId}`);

  return (
    <div className="newest-terms">
      <div className="newest-terms-header">
        <h2>Najnovšie prihlásenia</h2>
        <div className="term-count-selector">
          <label htmlFor="countSelect">Počet:</label>
          <select id="countSelect" value={count} onChange={(e) => setCount(e.target.value)}>
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="15">15</option>
            <option value="20">20</option>
          </select>
        </div>
      </div>
      <ul className="nt-list">
        {isLoading
          ? [1, 2, 3, 4, 5].map((i) => (
            <li key={`skel-${i}`} className="p-0 border-0 bg-transparent">
              <div className="skeleton-term w-100 m-0" style={{ height: '70px' }}></div>
            </li>
          ))
          : terms.map((term) => (
            <li
              key={term.id}
              className={`${hoveredTermId === term.id ? 'hovered' : ''}`}
              onMouseEnter={() => handleMouseEnter(term.id)}
              onMouseLeave={handleMouseLeave}
              onClick={() => handleTermClick(term.id)}
            >
              <div className='date'>
                <span className='time'>
                  <i className="bi bi-clock me-1"></i>
                  {formatTermTime(term)}
                </span>
                <span>
                  <i className="bi bi-calendar me-1"></i>
                  {formatDate(term.date)}
                </span>
              </div>
              <div className='details'>
                <span className='type'>{term.termType?.name}</span>
                <span className='user'>
                  <i className="bi bi-person me-1"></i>
                  {term.firstName} {term.lastName}
                </span>
              </div>
              <span className='rightdetail'>
                {term.updatedByUser ? formatTime(term.updatedByUser) + ' ' + formatDate(term.updatedByUser) : 'N/A'}
              </span>
            </li>
          ))}
      </ul>
    </div>
  );
};

export default NewestTerms;
